module.exports = __webpack_public_path__ + "static/media/frank.cb406510.jpg";